import Tooltip from '@mui/material/Tooltip';

import './JxHint.css';

const jxHintSx = {
    tooltip: { className: 'jx-hint' },
    popper: { className: 'jx-hint-popper' },
};

const hintPopperProps = {
    modifiers: [{ name: 'offset', options: { offset: [0, 10] } }],
};

/**
 * JxHint — documentation-style hover hint, distinct from JxTooltip.
 * JxTooltip is for short interaction tips (auto-hide, on/off via
 * tooltip.enabled). JxHint is for descriptive/documentation text (e.g. UML
 * class/member descriptions) that you actually want to read — no auto-hide
 * timer, no on/off setting (for now, always shown), closes on mouse-leave
 * like a normal MUI Tooltip.
 * @param {React.ReactNode} title
 * @param {React.ReactNode} children
 * @param {string} placement
 */
export default function JxHint({ title, children, placement = 'top' }) {
    if (!title) return children;

    return (
        <Tooltip
            title={title}
            placement={placement}
            disableInteractive
            PopperProps={hintPopperProps}
            componentsProps={jxHintSx}
        >
            {children}
        </Tooltip>
    );
}
